export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const CODE_VERIFIER_TOKEN_KEY = 'code_verifier';

export const setToken = (accessToken: string, refreshToken: string, codeVerifier: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(CODE_VERIFIER_TOKEN_KEY, codeVerifier);
};

export const getAccessTokenFromStorage = (): string | null =>
  localStorage.getItem(ACCESS_TOKEN_KEY);

export const getRefreshTokenFromStorage = (): string | null =>
  localStorage.getItem(REFRESH_TOKEN_KEY);

export const getCodeVerifierFromStorage = (): string | null =>
  localStorage.getItem(CODE_VERIFIER_TOKEN_KEY);

export const removeAuthTokenFromStorage = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(CODE_VERIFIER_TOKEN_KEY);
};
